import { useEffect, useRef, useState } from 'react';

const useAnimateOnScroll = () => {
  
// This function handles the visibility of cards when they enter the viewport
useEffect(() => {
  const cards = document.querySelectorAll('.card');
  
  // IntersectionObserver callback
  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      } else {
        entry.target.classList.remove('visible');
      }
    });
  };
  
  const options = {
    threshold: 0.5, // Trigger when 50% of the card is visible
  };

  const observer = new IntersectionObserver(observerCallback, options);
  
  // Observe each card
  cards.forEach(card => {
    observer.observe(card);
  });

  // Clean up observer on unmount
  return () => {
    cards.forEach(card => {
      observer.unobserve(card);
    });
  };
}, []);

}

export default useAnimateOnScroll;